import { createFileRoute } from '@tanstack/react-router';
import { PurchasingDashboard } from '@/features/purchasing/PurchasingDashboard';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/overview')({
  component: PurchasingDashboard,
});
